module.exports = __webpack_public_path__ + "static/media/logoudeablanco.0c8feac3.svg";